import * as React from "react"
import { cn } from "@/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <div className={cn("w-full group bg-secondary duration-200 transition-all", className)}>
      <div className="px-4">
        <input
          type={type}
          data-slot="input"
          className={cn(
            "w-full min-w-0 h-12 bg-transparent text-sm text-foreground",
            "placeholder:text-muted-foreground/50 outline-none",
            "file:inline-flex file:h-7 file:border-0 file:bg-transparent",
            "file:text-sm file:font-medium file:text-foreground",
            "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
            "aria-invalid:text-destructive",
          )}
          {...props}
        />
      </div>
      <div className="relative h-px bg-border">
        <div className="absolute inset-0 bg-foreground scale-y-0 group-focus-within:scale-y-[2] origin-bottom transition-transform duration-200" />
      </div>
    </div>
  )
}

export { Input }